export default __webpack_public_path__ + "static/media/planet.3f6fb274.png";